export default {
  SET_SEARCH_CITY: 'SET_SEARCH_CITY',
  GET_TOURS: {
    pending: 'GET_TOURS/pending',
    fulfilled: 'GET_TOURS/fulfilled',
    rejected: 'GET_TOURS/rejected'
  },
  FILTER_TOURS: 'FILTER_TOURS',
  UN_MOUNTED: 'UN_MOUNTED',
}


// WEBPACK FOOTER //
// ./src/app/containers/SearchResult/ActioTypes.js